<template>
<div>
    <div class="load-more-claims-wrapper">
        <router-link 
            :to="{name: 'search'}" class="load-more" 
            style="background-color: #DC0000;" type="button">Search our Database</router-link>
            <!-- -->
    </div>
    <div class="latest_claims">
	<h3 class="red-bar-section">
        <span>Fact Checker Claims</span>
        <div class="date_message">(From {{startDate}} - {{endDate}})</div>
    </h3>
	<div id="polling-data-rcp">
		<ClaimsTable 
            :claims="claims" 
            :loading="loading"
            :place-holder-number="placeHolderNumber"
            :display-links="displayLinks"
            />
	</div>
</div>
</div>
</template>

<script>

import ClaimsTable from './ClaimsTable.vue';

export default {
    name: 'fact-checker-claims-table',
    components: {
        ClaimsTable,
    },
    props: {
        claims: {
            type: Array,
            required: true,
        },
        startDate: {
            type: String,
            required: false,
            default: '',
        },
        endDate: {
            type: String,
            required: false,
            default: '',
        },
        loading: {
            default: false,
            required: false,
        },
        placeHolderNumber: {
            default: 20,
            required: false,
        },
        displayLinks: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
    },
}
</script>

<style lang="scss">
#fact-check-app{
    .latest_claims{
        #polling-data-rcp{
            table{
                tbody{
                    tr{
                        td.summary{
                            padding-left: 10px !important;
                        }
                    }
                }
            }
        }
    }

    .load-more-claims-wrapper{
        width: initial;
        margin: initial;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
    }
}
</style>